import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Home from './pages/Home'
import Gallery from './pages/Gallery'
import MenuViewer from './pages/MenuViewer';

function Routing () {
  return (
    <Routes>
      <Route path="/nossa-casa" exact element={<Gallery />} />
      <Route path="/nosso-cardapio" exact element={<MenuViewer />} />
      <Route path="/" exact element={<Home />} />
    </Routes>
  )
}

export default Routing;